import { isHttpClientError, type ResponseInterceptor } from './HttpClient'

type UnauthorizedInterceptorParams = {
  onUnauthorized: () => void
}

export function createUnauthorizedInterceptor({
  onUnauthorized,
}: UnauthorizedInterceptorParams): ResponseInterceptor {
  return function unauthorizedInterceptor(error: unknown) {
    if (
      (isHttpClientError(error) && error.response?.status === 401) ||
      (isHttpClientError(error) && error.response?.status === 403)
    ) {
      onUnauthorized()
    }

    return Promise.reject(error)
  }
}
